import request from '@/config/axios'

export interface AiAdvisorConfig {
  id?: number
  modelId?: number
  knowledgeId?: number
  dailyQuota: number
  paid: boolean
  productId?: number
  status: number
  version: number
}

export const getAiAdvisorPage = (params: any) =>
  request.get({ url: '/bosscircle/ai-advisor/page', params })
export const getAiAdvisorConfig = () =>
  request.get<AiAdvisorConfig>({ url: '/bosscircle/ai-advisor/config' })
export const saveAiAdvisorConfig = (data: Omit<AiAdvisorConfig, 'status'>) =>
  request.put({ url: '/bosscircle/ai-advisor/config', data })
export const updateAiAdvisorStatus = (status: number, version: number) =>
  request.put({ url: '/bosscircle/ai-advisor/status', data: { status, version } })
